import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "vip-page" }
const _hoisted_2 = { class: "vip-main" }
const _hoisted_3 = { class: "vip-shell" }
const _hoisted_4 = { class: "logo-icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "vip-hero" }
const _hoisted_7 = { class: "vip-hero-copy" }
const _hoisted_8 = {
  class: "vip-hero-benefits",
  "aria-label": "会员权益"
}
const _hoisted_9 = {
  class: "vip-hero-visual",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "vip-crown-card" }
const _hoisted_11 = { class: "vip-plan-stack" }
const _hoisted_12 = { class: "vip-plan-section" }
const _hoisted_13 = { class: "vip-plan-grid" }
const _hoisted_14 = {
  type: "button",
  class: "vip-plan-card active"
}
const _hoisted_15 = { class: "vip-plan-price" }
const _hoisted_16 = { class: "vip-footer" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "vip-info-card vip-benefits-card" }
const _hoisted_19 = { class: "vip-feature-list" }
const _hoisted_20 = { class: "vip-feature-icon" }
const _hoisted_21 = { class: "vip-feature-copy" }
const _hoisted_22 = { class: "vip-info-card vip-notes-card" }
const _hoisted_23 = { class: "vip-note-list" }
const _hoisted_24 = { class: "vip-note-copy" }
const _hoisted_25 = { class: "vip-payment-summary" }
const _hoisted_26 = { class: "vip-payment-amount" }
const _hoisted_27 = { class: "vip-payment-desc" }
const _hoisted_28 = { class: "vip-payment-methods" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "vip-payment-method-main" }
const _hoisted_31 = { class: "vip-payment-method-name" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["disabled"]

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import logo2Image from '../assets/logo2.png'
import { getVipPlanList, type VipPlan } from '@/api/vip-plan'
import { createAgentPay, getRegistrationCode } from '@/api/pay'
import { showFailToast, showSuccessToast } from 'vant'


export default /*@__PURE__*/_defineComponent({
  __name: 'agent',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const formatDate = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}


const plans = ref<VipPlan[]>()

const paymentMethods = [
  { id: 'alipay', name: '支付宝', icon: ['fab', 'alipay'] }
]

const features = [
  {
    title: '解锁全站学习内容',
    desc: '10000+集中英文儿歌动画，词卡、动画、分龄课程和后续新内容都可以持续使用。',
    icon: 'book-open'
  },
  {
    title: '成长节奏更连贯',
    desc: '学习记录、打卡进度和推荐内容会围绕孩子当前阶段持续更新。',
    icon: 'seedling'
  },
  {
    title: '更省心的陪学体验',
    desc: '减少频繁切换内容的成本，让家长可以直接进入陪学和复习节奏。',
    icon: 'heart'
  }
]

const notes = [
  {
    title: '会员服务为虚拟内容服务',
    desc: '支付成功后立即开通，立即解锁会员权益，无需兑换，不支持延时开通或未使用时长延期，不支持退款，请确认需求后再购买。'
  },
  {
    title: '会员有效期以支付成功时间开始计算',
    desc: '同一账号下购买新套餐后，会自动顺延或升级现有有效期。'
  },
  {
    title: '权益说明以页面展示为准',
    desc: '若后续上线新会员内容，已开通会员可在有效期内继续使用。'
  },
  {
    title: '如遇支付或账号问题可联系客服',
    desc: '我们会协助核对订单与会员状态，保障正常使用。'
  }
]

const selectedPlan = ref()
const selectedPaymentMethodId = ref('alipay')
const isPaymentModalOpen = ref(false)
const isPaymentResultModalOpen = ref(false)
const isPaying = ref(false)
const orderNo = ref('')

const openPaymentModal = () => {
  if (!selectedPlan.value) return
  isPaymentModalOpen.value = true
}

const closePaymentModal = () => {
  isPaymentModalOpen.value = false
}

const closePaymentResultModal = () => {
  isPaymentResultModalOpen.value = false
}

const getPayHtml = (payResponse: unknown) => {
  if (typeof payResponse === 'string') return payResponse
  if (payResponse && typeof payResponse === 'object') {
    const data = (payResponse as Record<string, unknown>).data
    if (typeof data === 'string') return data
  }
  return ''
}

const submitPayHtml = (payHtml: string, payWindow: Window | null) => {
  const html = payHtml.trim()
  if (!html) return

  if (payWindow && !payWindow.closed) {
    payWindow.document.open()
    payWindow.document.write(html)
    payWindow.document.close()
    return
  }

  const container = document.createElement('div')
  container.style.display = 'none'
  container.innerHTML = html
  document.body.appendChild(container)

  const form = container.querySelector('form')
  if (form instanceof HTMLFormElement) {
    form.submit()
  }
}

const isMobileDevice = () => {
  const userAgent = navigator.userAgent || ''
  const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent)
  const isCoarseSmallScreen = window.matchMedia('(pointer: coarse)').matches && window.matchMedia('(max-width: 768px)').matches

  return isMobileUserAgent || isCoarseSmallScreen
}

const handleConfirmPay = async() => {
  if (isPaying.value || !selectedPlan.value) return
  const isMobile = isMobileDevice()
  const payWindow: Window | null = isMobile ? null : window.open('', '_blank')
  // if (payWindow) {
  //   payWindow.document.write('<p style="font-family: sans-serif; padding: 24px;">正在前往支付...</p>')
  // }
  isPaying.value = true
  try {
    const res = await createAgentPay({payType: selectedPaymentMethodId.value==='wechat'?1:2, planId: selectedPlan.value.id, mobile: isMobile, agentId: route.params.code})
    orderNo.value = res.orderNo
    submitPayHtml(getPayHtml(res.body), payWindow)
    closePaymentModal()
    isPaymentResultModalOpen.value = true
  } catch {
    if (payWindow && !payWindow.closed) {
      payWindow.close()
    }
  } finally {
    isPaying.value = false
  }
}

const handlePaymentSuccess = async() => {
  getRegistrationCode(orderNo.value).then(res=>{
    if(res==null) {
      showFailToast('未收到支付成功通知，请稍后再试')
    } else {
      router.push({
        path: '/activate/'+res
      })
    }
  }).catch(err=>{
    
  })
}

const handlePaymentFail = () => {
  closePaymentResultModal()
}


const handleGoBack = () => {
  router.push({
    path: '/',
    query: {
      tab: 'profile'
    }
  })
}


const getPlans = async() => {
  try {
    plans.value = await getVipPlanList()
    for(let p of plans.value) {
      if(p.type==3) {
        selectedPlan.value = p
      }
    }
  } catch {
    // 套餐加载失败时保持当前页面默认状态
  }
}

onMounted(() => {
  getPlans()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "bg-decoration" }, [
      _createElementVNode("div", { class: "orb orb-1" }),
      _createElementVNode("div", { class: "orb orb-2" }),
      _createElementVNode("div", { class: "orb orb-3" })
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "vip-brand-row",
          to: "/",
          "aria-label": "返回首页"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(logo2Image),
                alt: "",
                class: "logo2-icon"
              }, null, 8, _hoisted_5)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "brand-copy" }, [
              _createElementVNode("h1", { class: "brand-name" }, "树苗英语"),
              _createElementVNode("span", { class: "brand-subtitle" }, "TREE SAPLING")
            ], -1))
          ]),
          _: 1
        }),
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "vip-hero-kicker" }, "树苗会员", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "vip-hero-name" }, "开启孩子的英语成长之旅", -1)),
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, { icon: "check-circle" }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "10000+ 英文儿歌动画、词卡、绘本、分级课程随心学", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, { icon: "check-circle" }),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "学习进度记录，个性化推荐更高效", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_font_awesome_icon, { icon: "check-circle" }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "纯净无广告环境，专注学习更放心", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "vip-sparkle vip-sparkle-1" }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "vip-sparkle vip-sparkle-2" }, null, -1)),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "vip-sparkle vip-sparkle-3" }, null, -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_font_awesome_icon, {
                icon: "crown",
                class: "vip-crown-icon"
              }),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "vip-crown-face" }, [
                _createElementVNode("span"),
                _createElementVNode("span"),
                _createElementVNode("i")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("section", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "vip-plan-heading" }, "购买年卡", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", _hoisted_14, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "vip-plan-name" }, " 年卡 ", -1)),
                _createElementVNode("span", _hoisted_15, [
                  _cache[12] || (_cache[12] = _createElementVNode("small", null, "¥", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedPlan.value?.price || '--'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("footer", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "vip-pay-btn",
              disabled: !selectedPlan.value,
              onClick: openPaymentModal
            }, " 立即购买 ", 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("section", _hoisted_18, [
          _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "vip-section-title" }, "为什么要买会员?", -1)),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature) => {
              return _createElementVNode("article", {
                key: feature.title,
                class: "vip-feature-item"
              }, [
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: feature.icon
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h4", null, _toDisplayString(feature.title), 1),
                  _createElementVNode("p", null, _toDisplayString(feature.desc), 1)
                ])
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("section", _hoisted_22, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "vip-section-title" }, "购买须知", -1)),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(notes, (note) => {
              return _createElementVNode("article", {
                key: note.title,
                class: "vip-note-item"
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "vip-note-dot" }, null, -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h4", null, _toDisplayString(note.title), 1),
                  _createElementVNode("p", null, _toDisplayString(note.desc), 1)
                ])
              ])
            }), 64))
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isPaymentModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vip-payment-mask",
              onClick: closePaymentModal
            }, [
              _createElementVNode("section", {
                class: "vip-payment-modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "vip-payment-close",
                  "aria-label": "关闭支付弹窗",
                  onClick: closePaymentModal
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("header", { class: "vip-payment-header" }, [
                  _createElementVNode("h3", { class: "vip-payment-title" }, "选择支付方式")
                ], -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, "¥" + _toDisplayString(selectedPlan.value?.price || '--'), 1),
                  _createElementVNode("p", _hoisted_27, "树苗英语 - " + _toDisplayString(selectedPlan.value?.duration || '年卡'), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentMethods, (method) => {
                    return _createElementVNode("button", {
                      key: method.id,
                      type: "button",
                      class: _normalizeClass(["vip-payment-method", { active: selectedPaymentMethodId.value === method.id }]),
                      onClick: ($event: any) => (selectedPaymentMethodId.value = method.id)
                    }, [
                      _createElementVNode("span", _hoisted_30, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["vip-payment-method-icon", `vip-payment-method-icon-${method.id}`]),
                          "aria-hidden": "true"
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: method.icon
                          }, null, 8, ["icon"])
                        ], 2),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(method.name), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["vip-payment-method-check", { active: selectedPaymentMethodId.value === method.id }])
                      }, [
                        (selectedPaymentMethodId.value === method.id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "✓"))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 10, _hoisted_29)
                  }), 64))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "vip-payment-confirm",
                  disabled: isPaying.value || !selectedPlan.value,
                  onClick: handleConfirmPay
                }, _toDisplayString(isPaying.value ? '正在发起支付...' : `确认支付 ¥${selectedPlan.value?.price || '--'}`), 9, _hoisted_33)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isPaymentResultModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "vip-payment-mask",
              onClick: closePaymentResultModal
            }, [
              _createElementVNode("section", {
                class: "vip-payment-modal vip-payment-result-modal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "vip-payment-close",
                  "aria-label": "关闭支付结果弹窗",
                  onClick: closePaymentResultModal
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "vip-payment-result-text" }, "充值完成后，根据您的情况点击下面按钮。", -1)),
                _createElementVNode("div", { class: "vip-payment-result-actions" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "vip-payment-result-success",
                    onClick: handlePaymentSuccess
                  }, " 支付成功 "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "vip-payment-result-fail",
                    onClick: handlePaymentFail
                  }, " 支付失败 ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})